import { HttpContextToken } from "@angular/common/http";

/**
 * Http Context Token for Loading Show
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Loading Show
 * @description Http Context Token for Loading Show
 * @example
 * ```typescript
 * const loadingShowContext = new HttpContextToken<boolean>(() => true);
 * ```
 */
export const LOADING_SHOW_CONTEXT = new HttpContextToken<boolean>(() => false);